<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
    </div>
    <h2 class="dialog-title">Rechercher une adresse {{ data }}</h2>
    <button type="button" class="btn-icon" mat-dialog-close>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="search-section">
      <label class="form-label">Saisir l'adresse à rechercher</label>
      <div class="search-box">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          class="search-input"
          type="text"
          [(ngModel)]="address"
          (ngModelChange)="onAddressInputChange($event)"
          placeholder="Ex: Cocody, Rue D33, Rivièra 2...">
      </div>
    </div>

    <div *ngIf="sharedUtilsService.estEnChargement" class="loading-container">
      <div class="spinner"></div>
      <p>Recherche en cours...</p>
    </div>

    <div *ngIf="!sharedUtilsService.estEnChargement && sharedUtilsService.suggestions.length > 0" class="suggestions-container">
      <p class="results-info">{{ sharedUtilsService.suggestions.length }} résultat(s) trouvé(s)</p>
      <p class="results-hint">Cliquez sur une adresse pour la sélectionner automatiquement.</p>
      <div class="suggestions-list">
        <div
          *ngFor="let suggestion of sharedUtilsService.suggestions"
          (click)="selectSuggestion(suggestion)"
          class="suggestion-item">
          <div class="suggestion-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </div>
          <div class="suggestion-content">
            <div class="suggestion-name">{{ suggestion.display_name }}</div>
            <div class="suggestion-subtitle">Sélectionner cette adresse</div>
          </div>
          <div class="suggestion-action">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!sharedUtilsService.estEnChargement && address && sharedUtilsService.suggestions.length === 0" class="empty-state">
      <div class="empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
          <path d="M8 8l6 6M14 8l-6 6" stroke-width="1.5"></path>
        </svg>
      </div>
      <p>Aucune adresse trouvée pour "{{ address }}"</p>
      <span class="empty-hint">Essayez avec des mots-clés différents</span>
    </div>

    <div *ngIf="!address && !sharedUtilsService.estEnChargement" class="empty-state initial">
      <div class="empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      </div>
      <p>Saisissez une adresse pour commencer la recherche</p>
    </div>
  </mat-dialog-content>

  <div class="dialog-actions" *ngIf="adressSelected">
    <button type="button" class="btn btn-primary" (click)="closeDialogue()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      Sélectionner cette adresse
    </button>
  </div>
</div>
